import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CAMIONES_ENTRE_PLAYA_CALADO } from '../../../../config/tables'

export default function TablaCamionesEntrePlayaCaladoView () {
  return (
    <MuiTable id={TABLA_CAMIONES_ENTRE_PLAYA_CALADO} />
  )
}
